module.exports = __webpack_public_path__ + "static/img/rico.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rico.png
// module id = henE
// module chunks = 0